"use client";
import { cva as e } from "class-variance-authority";
const r = e(
  [
    // Base styles
    "inline-flex",
    "items-center",
    "justify-center",
    "align-middle",
    "select-none",
    "relative",
    "whitespace-nowrap",
    "appearance-none",
    "rounded-md",
    "leading-[1.2]",
    "transition-all",
    "duration-300",
    "cursor-pointer",
    "font-semibold",
    // Focus styles
    "focus:outline-none",
    "focus:z-base",
    "focus-visible:ring",
    // Disabled styles
    "disabled:opacity-40",
    "disabled:cursor-not-allowed",
    "disabled:shadow-none"
  ],
  {
    variants: {
      variant: {
        solid: [
          "bg-gray-100 dark:bg-white-alpha-100",
          "text-gray-800 dark:text-white-alpha-950",
          "hover:bg-gray-200 dark:hover:bg-white-alpha-200",
          "hover:disabled:bg-gray-100 dark:hover:disabled:bg-white-alpha-100",
          "active:bg-gray-300 dark:active:bg-white-alpha-400"
        ],
        iconButton: [
          "px-1 text-gray-500 text-md",
          "hover:text-inkeep-primary-strong",
          "dark:text-gray-dark-200",
          "dark:hover:text-inkeep-expanded-primary-300"
        ],
        ghost: [
          "text-gray-800 dark:text-white-alpha-950",
          "hover:bg-gray-100 dark:hover:bg-white-alpha-100",
          "active:bg-gray-200 dark:active:bg-white-alpha-200"
        ],
        outline: [
          "border dark:border-white-alpha-200",
          "text-gray-600 dark:text-gray-200",
          "hover:bg-gray-50 dark:hover:bg-white-alpha-100",
          "active:bg-gray-50 dark:active:bg-white-alpha-100"
        ]
      },
      size: {
        sm: "h-8 min-w-8 text-sm px-3",
        md: "h-10 min-w-10 text-md px-4",
        xs: "h-6 min-w-6 text-xs px-2"
      },
      preset: {
        neutralFilled: [
          "bg-gray-1000 text-white hover:bg-gray-900 active:bg-gray-900",
          "dark:bg-inkeep-expanded-primary-300 dark:text-gray-dark-950",
          "dark:hover:bg-inkeep-expanded-primary-200",
          "dark:active:bg-inkeep-expanded-primary-200"
        ]
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
);
export {
  r as button
};
